import React from 'react';
import SubscribeForm from './SubscribeForm';

export default function StayInTouch() {
  return (
    <section aria-labelledby="stay-in-touch-heading" className="bg-[#581C32] text-white">
      <div className="mx-auto grid w-full max-w-screen-xl gap-8 px-4 py-10 md:px-6 md:py-12 lg:grid-cols-2 lg:gap-14 lg:px-8">
        <div>
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-[#C6A667]">Stay in touch</p>
          <h2 id="stay-in-touch-heading" className="mt-3 text-2xl font-extrabold leading-tight tracking-tight sm:text-3xl">
            Get practical tips for starting and running a care business
          </h2>
          <p className="mt-3 text-base leading-relaxed text-white/85">
            Join our mailing list for guidance, updates and offers from Linda Dube, Care Business Coach and Social Care Entrepreneur, and Care Business School. No spam, and
            you can unsubscribe at any time.
          </p>
        </div>
        <div className="relative">
          <SubscribeForm defaultSource="footer" tone="dark" />
        </div>
      </div>
    </section>
  );
}
